
import Vue from "vue";
import { Fetcher } from "@/utils/Request";
import { isEmptyOrWhiteSpace } from "@/utils/Common";

    declare interface MainData {
        defaultImageSrc: string;
        imageSrc: string;
    }

export default Vue.extend({
  name: "AccountMainLayout",
  props: {
    userCls: String,
    title: {
      type: String,
      required: true
    }
  },
  data: function (): MainData {
    return {
      defaultImageSrc: "images/login-bg.png",
      imageSrc: "images/login-bg.png"
    };
  },

  created() {
    this.initLoginBackgroundImg();
  },

  methods: {
    initLoginBackgroundImg() {
      const key = "LOGIN_BACKGROUND_IMAGE";
      const oldSrc = window.localStorage.getItem(key);
      if (!isEmptyOrWhiteSpace(oldSrc)) {
        this.imageSrc = this.defaultImageSrc;
      }
      Fetcher.queryData("/opened/bgimg", {}, "GET", false).then((src: string) => {
        if (isEmptyOrWhiteSpace(src)) {
          window.localStorage.removeItem(key);
          this.imageSrc = this.defaultImageSrc;
        } else {
          this.imageSrc = src;
          window.localStorage.setItem(key, src);
        }
      });
    },
    setDefaultLogin() {
      this.imageSrc = this.defaultImageSrc;
    }
  }
});
